import objectAssign from '../src/object-assign';

export default objectAssign();
